module.exports = __webpack_public_path__ + "img/a085ecb.png";